import React from 'react'

const More = () => {
  return (
    <section id='more' className='max-w-screen-xl mx-auto w-full h-[800px] pb-20 py-20 text-lightText flex border-b-[1px border-b-black'>
    <div className='flex flex-col gap-6 font-titleFont'>
    <h3 className='uppercase text-sm font-light text-designColor tracking-wide'>fundings and more</h3>
    <h1 className='text-5xl text-gray-300 font-bold'>More about us</h1>
    <p> 
    Lorem ipsum dolor sit amet consectetur adipisicing elit.
    </p>
    </div>
    </section>
  )
}

export default More